import React from "react";

const PieContext = React.createContext<{
  dataEstadistica: any[]; //Se llena con los datos filtrado
  actualizaDataEstadistica(dataE: any[]): void;
  dataEstadisticaFiltered: any[];
  actualizaDataEstadisticaFiltered(data: any[]): void;
  dataEstadisticaPaged: any[];
  actualizaDataEstadisticaPaged(dataE: any[]): void;
  añosSelect: number[];
  actualizaAñosSelect(años: number[]): void;
  filtrosSelect: any;
  actualizaFiltros(filtros: any): void;
  dataEstatica: any[]; //Data completa de la consulta
  actualizaDataEstatica(data: any[]): void
}>({
  dataEstadistica: [],
  actualizaDataEstadistica: () => {},
  dataEstadisticaFiltered: [],
  actualizaDataEstadisticaFiltered: () => {},
  dataEstadisticaPaged: [],
  actualizaDataEstadisticaPaged: () => {},
  añosSelect: [],
  actualizaAñosSelect: () => {},
  filtrosSelect: {},
  actualizaFiltros:() => {},
  dataEstatica: [],
  actualizaDataEstatica: () => {},
});

export default PieContext;
